import { render, staticRenderFns } from "./feedBackDetails.vue?vue&type=template&id=e07e7b8a&scoped=true"
import script from "./feedBackDetails.vue?vue&type=script&lang=js"
export * from "./feedBackDetails.vue?vue&type=script&lang=js"
import style0 from "./feedBackDetails.vue?vue&type=style&index=0&id=e07e7b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e7b8a",
  null
  
)

export default component.exports